import * as React from 'react';

import { HeroBentoModule } from '@coursera-web/cds-labs';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';
import CampaignHeroModuleRenderer, {
  useShouldShowCampaignHeroModule,
} from 'bundles/campaigns/module-renderers/CampaignHeroModuleRenderer';
import SeoPageHeader from 'bundles/front-page/components/modules/hero-banner/SeoPageHeader';
import { useFrontPageRedesignQ32025Data } from 'bundles/front-page/providers/FrontPageRedesignQ32025Provider';
import NonNamerHeroBentoModuleRenderer from 'bundles/front-page/redesign-modules/hero-banner/NonNamerHeroBentoModuleRenderer';
import getPredefinedPromos from 'bundles/front-page/redesign-modules/hero-banner/data/getPredefinedPromos';

const HeroBannerSliderModuleRenderer = () => {
  const shouldShowCampaignHeroModule = useShouldShowCampaignHeroModule();
  const { campaignData } = useCampaignModulesData();
  const { enableFrontPageRedesignNonNamer } = useFrontPageRedesignQ32025Data();

  let heroModuleOutput;

  if (shouldShowCampaignHeroModule) {
    // Render hero bento module for non-NAMER
    if (
      enableFrontPageRedesignNonNamer &&
      campaignData?.heroModule?.contentDataJson?.__typename === 'PromoTemplateHero'
    ) {
      return <NonNamerHeroBentoModuleRenderer />;
    }

    heroModuleOutput = <CampaignHeroModuleRenderer />;
  } else {
    const defaultCards = getPredefinedPromos();
    const cards = [defaultCards.joinForFree, defaultCards.c4b, defaultCards.promoCert];

    heroModuleOutput = <HeroBentoModule cards={cards} />;
  }

  return (
    <div>
      <SeoPageHeader />
      {heroModuleOutput}
    </div>
  );
};

export default HeroBannerSliderModuleRenderer;
